import React from 'react'
import { RichScriptEditor } from './rich-script-editor'

export const LineTextEditor: React.FC<{
  lineId: string
  text: string
  onTextChange: (text: string) => void
  onTextBlur: () => void
  onTextFocus: () => void
}> = ({ text, onTextChange, onTextBlur, onTextFocus }) => {
  return (
    <div className="relative">
      <RichScriptEditor
        text={text}
        onTextChange={onTextChange}
        onTextBlur={onTextBlur}
        onTextFocus={onTextFocus}
      />
    </div>
  )
}
